import { S3FileStatus } from '~/lib/constants/s3filestatus.contants';
import { getPatientDocumentExternalIdFromFileName } from '~/lib/util/chat/chatAttachments.util';
import api from '~/store/services/api';

interface GetPatientDocumentDownloadURLRequest {
  fileName: string;
  patientExternalId: string;
}

export interface GetPatientDocumentDownloadURLResponse {
  attachmentDownloadUrl?: string;
  fileValidationStatus?: S3FileStatus;
  isValidFile?: boolean;
}

const chatDocumentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPatientDocumentDownloadURL: build.query<
      GetPatientDocumentDownloadURLResponse,
      GetPatientDocumentDownloadURLRequest
    >({
      query: ({ fileName, patientExternalId }) => {
        const encodedFileName = encodeURIComponent(fileName);
        const documentExternalId =
          getPatientDocumentExternalIdFromFileName(fileName);

        return {
          url: `/clinical-data/patient-document/${patientExternalId}/download-url/${encodedFileName}?documentExternalId=${documentExternalId}`,
        };
      },
    }),
  }),
});

export const { useLazyGetPatientDocumentDownloadURLQuery } = chatDocumentsApi;
